import { cn, emptyFragment } from '@execonline-inc/execonline-ui';
import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import ReactHtmlParser from 'react-html-parser';
import { HtmlParserNode } from '../../../../../SegmentStore/Types';
import { sanitizeHtml } from '../../../../../Utils/sanitizeHtml';
import { htmlANodeDecoder, htmlImgNodeDecoder } from './HtmlDecoders';
import HtmlImageView from './HtmlImageView';
import './styles.css';

interface Props {
  className?: string;
  description: AlreadyTranslatedText;
}

function HtmlView({ description, className }: Props) {
  const transform = (node: HtmlParserNode, index: number) => {
    switch (node.name) {
      case 'img': {
        return htmlImgNodeDecoder.decodeAny(node).cata({
          Err: emptyFragment,
          Ok: (data) => {
            return <HtmlImageView key={index} src={data.attribs.src} />;
          },
        });
      }
      case 'a': {
        return htmlANodeDecoder.decodeAny(node).cata({
          Err: emptyFragment,
          Ok: (data) => {
            const linkText = fromArrayMaybe(node.children)
              .map((children) => children.first.data)
              .map((text) => text.trim() || '')
              .filter((text) => text.length > 0)
              .getOrElseValue(data.attribs.href);

            return (
              <a
                key={index}
                className="htmlParserLink"
                href={data.attribs.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkText}
              </a>
            );
          },
        });
      }
    }
  };

  return fromEmpty(description.text).cata({
    Just: (text) => (
      <div
        className={cn(
          'htmlParserWrapper',
          'text-font-size-md text-neutral-900 xl:text-font-size-lg',
          className,
        )}
        tabIndex={0}
      >
        {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- react-html-parser is untyped
          ReactHtmlParser(sanitizeHtml(text), { transform })
        }
      </div>
    ),
    Nothing: emptyFragment,
  });
}

export default observer(HtmlView);
